(function() {
    let $form;

    function init() {
        $form = document.querySelector('.newsletter');
        if (!$form) {
            return;
        }

        $form.addEventListener('submit', onSubmit);
    }

    async function onSubmit(event) {
        event.preventDefault();

        const $fields = $form.querySelector('.js--fields');
        const $submitButton = $form.querySelector('button');
        const $buttonText = $form.querySelector('.js--text');
        const $buttonLoadingIndicator = $form.querySelector('.js--loading');
        const $errorMessage = $form.querySelector('.js--error');
        const $successMessage = $form.querySelector('.js--success');

        if (!$errorMessage.classList.contains('hidden')) {
            $errorMessage.classList.add('hidden');
        }

        $submitButton.setAttribute('disabled', 'disabled');
        $buttonText.classList.add('hidden');
        $buttonLoadingIndicator.classList.remove('hidden');

        const endpoint = $form.getAttribute('action');
        const method = $form.getAttribute('method');

        const formData = new FormData($form);

        try {
            const result = await fetch(endpoint, {
                method: method,
                body: formData,
            });

            if (result.status >= 200 && result.status <= 299) {
                $fields.classList.add('hidden');
                $successMessage.classList.remove('hidden');
                document.cookie =
                    'newsletter_subscribed=1; path=/; max-age=' +
                    60 *
                    60 *
                    24 *
                    365;
            } else {
                const data = await result.json().catch(() => ({}));
                const isGdpr = data.message === 'gdpr_deleted';
                $errorMessage.querySelector('.js--error-generic').classList.toggle('hidden', isGdpr);
                $errorMessage.querySelector('.js--error-gdpr').classList.toggle('hidden', !isGdpr);
                $errorMessage.classList.remove('hidden');
            }
        } catch (ex) {
            console.error(ex);
            $errorMessage.querySelector('.js--error-generic').classList.remove('hidden');
            $errorMessage.querySelector('.js--error-gdpr').classList.add('hidden');
            $errorMessage.classList.remove('hidden');
        } finally {
            $submitButton.removeAttribute('disabled');
            $buttonText.classList.remove('hidden');
            $buttonLoadingIndicator.classList.add('hidden');
        }
    }

    document.addEventListener('DOMContentLoaded', init);
}());
